import { useSeo } from "@/hooks/useSeo";
import LegalLayout, { LegalSection, ReviewNote } from "@/components/LegalLayout";
import { business } from "@/data/site";

const Accessibility = () => {
  useSeo({ title: `Accessibility Statement | ${business.name}`, description: `${business.name} is committed to making its website accessible to all users, including people with disabilities.` });
  return (
    <LegalLayout eyebrow="Legal" title="Accessibility Statement" updated="June 2026">
      <p className="text-[#475569] leading-relaxed">{business.name} is committed to ensuring digital accessibility for people with disabilities. We are continually improving the user experience for everyone and applying relevant accessibility standards.</p>

      <LegalSection heading="Our Commitment">
        <p>We believe every visitor should be able to access information about our plumbing, electrical, and HVAC services with ease, regardless of ability or technology used.</p>
      </LegalSection>
      <LegalSection heading="Conformance Standards">
        <p>We aim to conform to the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA where reasonably practicable. These guidelines explain how to make web content more accessible for people with a wide range of disabilities.</p>
      </LegalSection>
      <LegalSection heading="Ongoing Efforts">
        <p>Accessibility is an ongoing effort. We regularly review our website and work to identify and resolve any barriers. As we add new content and features, we strive to maintain and improve accessibility.</p>
      </LegalSection>
      <LegalSection heading="Feedback & Support">
        <p>If you encounter any accessibility barriers on our website, or need assistance accessing any part of our services, please let us know. We welcome your feedback and will make reasonable efforts to provide the information or service you need through an alternative method.</p>
        <p>Contact us at <a href={business.emailHref} className="text-[#059669] font-semibold hover:underline">{business.email}</a> or {business.phoneDisplay}.</p>
        <ReviewNote>Confirm the best accessibility support contact (email/phone) and add a dedicated accessibility contact if the client has one.</ReviewNote>
      </LegalSection>
    </LegalLayout>
  );
};

export default Accessibility;
